import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'
import loginThen from '@/components/login/loginThen'
import Reg from '@/components/login/reg'
import Register1 from '@/components/login/register1'
import Register2 from '@/components/login/register2'
import Register3 from '@/components/login/register3'
import registration from '@/components/login/registration'
import registerView from '@/components/login/registerView'
import simpleReg from '@/components/login/simpleReg'
import uploadPaper from '@/components/login/uploadPaper'
import uploadPaperDetail from '@/components/login/uploadPaperDetail'
import submissionUpload from '@/components/login/submissionUpload'
import payment from '@/components/login/payment'
import subUpThen from '@/components/login/subUpThen'
import MembersList from '@/components/membersList'

import Index from '@/components/index'
import Introduction from '@/components/Introduction'
import GovernanceAndBylaws from '@/components/GovernanceAndBylaws'
import committees from '@/components/committees'
import MembershipIntroduction from '@/components/MembershipIntroduction'
import fellow from '@/components/fellow'
import member from '@/components/iradstmMember'
import AssociateFellow from '@/components/AssociateFellow'

import IradstmAnnualMeeting from '@/components/IradstmAnnualMeeting'
import ids from '@/components/ids'
import adc from '@/components/adc'
import eurodrying from '@/components/eurodrying'
import fdic from '@/components/fdic'
import otherConferences from '@/components/otherConferences'
import Submissions from '@/components/login/submissions'


import advertisement from '@/components/Advertisement'

import IRADSTMNews from '@/components/IRADSTMNews'
import DevelopmentNews from '@/components/DevelopmentNews'
import IADSTNews from '@/components/IADSTNews'
import newsContent from '@/components/newsContent'
import committeesDetail from '@/components/committeesDetail'
import committeesDetail2 from '@/components/committeesDetail2'
import ConferenceEvents from '@/components/ConferenceEvents'
import RichTextEditor from '@/components/RichText'
import eventsContent from '@/components/eventsContent'
import ConferenceNews from '@/components/ConferenceNews'
import ConferenceNewsContent from '@/components/ConferenceNewsContent'
import webContent from '@/components/webContent'
import LectureHall from '@/components/LectureHall'
import meetingContent from '@/components/meetingContent'

Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'index',
		component: Index,
	},
	{
		path: "/meetingContent",
		name: "meetingContent",
		component: meetingContent
	},
	{
		path: "/Global-Drying-Lecture-Hall",
		name: "LectureHall",
		component: LectureHall
	},
	{
		path: "/Conference-News-Content",
		name: "ConferenceNewsContent",
		component: ConferenceNewsContent
	},
	{
		path: "/Conference-News",
		name: "ConferenceNews",
		component: ConferenceNews
	},
	{
		path: "/FellowDetail",
		name: "committeesDetail",
		component: committeesDetail
	},
	{
		path: "/AssociateFellowDetail",
		name: "committeesDetail2",
		component: committeesDetail2
	},
	{
		path: "/Upcoming-Events",
		name: "ConferenceEvents",
		component: ConferenceEvents
	},
	{
		path: "/news-content",
		name: "newsContent",
		component: newsContent
	},
	{
		path: "/web-content",
		name: "webContent",
		component: webContent
	},
	{
		path: "/Events-content",
		name: "eventsContent",
		component: eventsContent
	},
	{
		path: '/advertisement',
		name: 'advertisement',
		component: advertisement
	},
	{
		path: '/registerView',
		name: 'registerView',
		component: registerView
	},
	{
		path: '/submissions',
		name: 'submissions',
		component: Submissions
	},
	{
		path: '/reg',
		name: 'reg',
		component: Reg
	}, {
		path: '/register1',
		name: 'register1',
		component: Register1
	}, {
		path: '/members',
		name: 'members',
		component: MembersList
	}, {
		path: '/register2',
		name: 'register2',
		component: Register2
	}, {
		path: '/register3',
		name: 'register3',
		component: Register3
	}, {
		path: '/login',
		name: 'login',
		component: Login
	}, {
		path: '/loginThen',
		name: 'loginThen',
		component: loginThen
	}, {
		path: '/uploadPaper',
		name: 'uploadPaper',
		component: uploadPaper
	}, {
		path: '/uploadPaperDetail',
		name: 'uploadPaperDetail',
		component: uploadPaperDetail
	}, {
		path: '/registration',
		name: 'registration',
		component: registration
	}, {
		path: '/payment',
		name: 'payment',
		component: payment
	}, {
		path: '/submissionUpload',
		name: 'submissionUpload',
		component: submissionUpload
	}, {
		path: '/subUpThen',
		name: 'subUpThen',
		component: subUpThen
	}, {
		path: '/simpleReg',
		name: 'simpleReg',
		component: simpleReg
	},
	{
		path: '/iradstm-introduction',
		name: 'Introduction',
		component: Introduction
	},
	{
		path: '/governance-and-bylaws',
		name: 'GovernanceAndBylaws',
		component: GovernanceAndBylaws
	}, {
		path: "/committees",
		name: "committees",
		component: committees
	}, {
		path: "/membership-introduction-join-IRADSTM",
		name: "MembershipIntroduction",
		component: MembershipIntroduction
	}, {
		path: "/iadst-fellow",
		name: "fellow",
		component: fellow
	}, {
		path: "/IRADSTM-memberships",
		name: "member",
		component: member
	}, {
		path: "/iadst-associate-fellow",
		name: "AssociateFellow",
		component: AssociateFellow
	}, {
		path: "/iradstm-annual-meeting",
		name: "IradstmAnnualMeeting",
		component: IradstmAnnualMeeting
	}, {
		path: "/ids",
		name: "ids",
		component: ids
	}, {
		path: "/adc",
		name: "adc",
		component: adc
	}, {
		path: "/eurodrying",
		name: "eurodrying",
		component: eurodrying
	}, {
		path: "/fdic",
		name: "fdic",
		component: fdic
	}, {
		path: "/other-conferences",
		name: "otherConferences",
		component: otherConferences
	}, {
		path: "/IRADSTM-News",
		name: "IRADSTMNews",
		component: IRADSTMNews
	}, {
		path: "/Development-News",
		name: "DevelopmentNews",
		component: DevelopmentNews
	}, {
		path: "/IADST-News",
		name: "IADSTNews",
		component: IADSTNews
	}, {
		path: "/richTextEditor",
		name: "richTextEditor",
		component: RichTextEditor
	}


	],
})


// WEBPACK FOOTER //
// ./src/router/index.js